import { ContinueType, NodeTypes, TextContentHighlightMod, TextContentType, ChatbotNode } from '@myriadgenetics/mgh-types';
import { NODE_IDS } from '../constants';
import { getNextComponentId } from '../../../../helpers/components';

export const patientLocationNode: ChatbotNode = {
  id: NODE_IDS.PERSONAL_HISTORY_INTRO_NODE,
  name: 'Chatbot PHx Intro',
  description: 'Chatbot PHx Intro',
  type: NodeTypes.Chat,
  data: {
    continueType: ContinueType.AutoEnd,
    pageTitleKey: 'pageTitles.chatbot.personalHistoryIntroNode',
  },
  components: [
    {
      id: getNextComponentId(),
      type: 'TEXT_CONTENT',
      name: 'Get Started w/PHx',
      description: 'Example of chat',
      data: {
        contentKey: 'chatbot.personalHistory.fewQuestions',
        type: TextContentType.Text1,
        highlightModifier: TextContentHighlightMod.Primary,
        delay: 1000,
        avatarSvg: 'chatbot.hcpAvatar',
        position: 'left',
      },
    },
  ],
  flows: [
    {
      id: -1,
      name: 'Unconditional',
      description: 'To Personal History',
      type: 'UNCONDITIONAL',
      data: {
        nextPageId: NODE_IDS.PERSONAL_HISTORY_NODE,
      },
    },
  ],
};

export default patientLocationNode;
